import { render, staticRenderFns } from "./Vehicles.vue?vue&type=template&id=257584a8&scoped=true"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"
import style0 from "./Vehicles.vue?vue&type=style&index=0&id=257584a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257584a8",
  null
  
)

export default component.exports